/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: "24578007-9f82-4980-9f18-c47600ae95d4",
    authority:
      "https://login.microsoftonline.com/6f6cf8a8-56d6-4a22-a8cc-27cc765e990a",
    // Derived from the current origin so this never needs hand-editing per
    // environment (localhost, dev, staging, prod) before a build.
    redirectUri: `${window.location.origin}/`,
  },
  cache: {
    // localStorage (not sessionStorage) so the MSAL state/nonce/PKCE cache
    // reliably survives the full-page round trip of the redirect login flow
    // across browsers (Safari/Brave/Firefox privacy modes can behave
    // inconsistently with sessionStorage across a cross-origin navigation).
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  // system: {
  //     loggerOptions: {
  //         loggerCallback: (level, message, containsPii) => {
  //             if (containsPii) {
  //                 return;
  //             }
  //             switch (level) {
  //                 case LogLevel.Error:
  //                     console.error("msal-auth-err==>",message);
  //                     return;
  //                 case LogLevel.Info:
  //                     console.info("msal-auth-info==>",message);
  //                     return;
  //                 case LogLevel.Verbose:
  //                     console.debug("msal-auth-debug==>",message);
  //                     return;
  //                 case LogLevel.Warning:
  //                     console.warn("msal-auth-warn==>",message);
  //                     return;
  //                 default:
  //                     return;
  //             }
  //         }
  //     }
  // }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ["User.Read"],
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me", //e.g. https://graph.microsoft.com/v1.0/me
};
